import { format, parseISO, differenceInCalendarDays, isValid } from "date-fns";

export const fmtMoney = (n) => {
  const v = Number(n || 0);
  return v.toLocaleString("en-AU", { style: "currency", currency: "AUD" });
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    const d = typeof iso === "string" ? parseISO(iso) : iso;
    if (!isValid(d)) return iso;
    return format(d, "MMM d, yyyy");
  } catch {
    return iso;
  }
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try {
    const d = typeof iso === "string" ? parseISO(iso) : iso;
    if (!isValid(d)) return iso;
    return format(d, "MMM d, yyyy • h:mm a");
  } catch {
    return iso;
  }
};

export const daysUntilDue = (dueIso) => {
  if (!dueIso) return null;
  try {
    return differenceInCalendarDays(parseISO(dueIso), new Date());
  } catch {
    return null;
  }
};

export const STATUS_META = {
  paid: { label: "Paid", color: "green" },
  part_paid: { label: "Part Paid", color: "yellow" },
  part_paid_overdue: { label: "Part Paid • Overdue", color: "red" },
  overdue: { label: "Overdue", color: "red" },
  due_soon: { label: "Due Soon", color: "yellow" },
  unpaid: { label: "Unpaid", color: "slate" },
};

export const statusChipClass = (status) => {
  const map = {
    paid: "bg-green-50 text-green-800 border-green-300",
    part_paid: "bg-amber-50 text-amber-800 border-amber-300",
    part_paid_overdue: "bg-red-50 text-red-800 border-red-300",
    overdue: "bg-red-50 text-red-800 border-red-300",
    due_soon: "bg-amber-50 text-amber-900 border-amber-400",
    unpaid: "bg-neutral-50 text-neutral-700 border-neutral-300",
  };
  return map[status] || map.unpaid;
};
